import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Form, Table } from 'react-bootstrap';
import { object } from 'prop-types';

import TransactionStatusBadge from './TransactionStatusBadge';
import { ToastContext } from './context/ToastContext';

function WalletTransactions({ user }) {
    const { sendMessage } = useContext(ToastContext);
    const [transactions, setTransactions] = useState([]);
    const [displayableId, setDisplayableId] = useState('');
    const [loading, setLoading] = useState(true);

    const fetchTransactions = useCallback(async () => {
        if (!user) {
            return;
        }
        try {
            const url = new URL(`/api/user/${user.id}/transactions`, process.env.APP_URL);
            if (displayableId.length) {
                url.searchParams.append('displayableId', displayableId);
            }
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
            });
            const { transactions, error } = await response.json();
            if (error) {
                sendMessage(error, 'danger');
            }
            if (transactions) {
                setTransactions(transactions);
            }
        } catch (e) {
            sendMessage(e.message, 'danger');
        } finally {
            setLoading(false);
        }
    }, [user, displayableId]);

    const handleDisplayableIdChange = useCallback((e) => setDisplayableId(e.target.value), [setDisplayableId]);

    useEffect(() => {
        fetchTransactions();
    }, [fetchTransactions]);

    return (
        <>
            <Form.Group
                className={'mb-3'}
                style={{ maxWidth: '40%' }}
            >
                <Form.Label>Transaction displayable Id</Form.Label>
                <Form.Control
                    type={'text'}
                    placeholder={'Enter displayable Id'}
                    value={displayableId}
                    onChange={handleDisplayableIdChange}
                />
            </Form.Group>
            {loading ? <div>Loading transactions...</div> : null}
            {!loading && !transactions.length ? <div>No transactions for this account.</div> : null}
            {transactions.length ? (
                <Table
                    striped
                    bordered
                    hover
                    responsive
                >
                    <thead>
                        <tr>
                            <th>Displayable ID</th>
                            <th>Email</th>
                            <th>Amount</th>
                            <th>Gateway</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {transactions.map(({ id, displayableId, status, gateway, amount, email }) => (
                            <tr
                                key={id}
                            >
                                <td>{displayableId}</td>
                                <td>{email}</td>
                                <td>${amount}</td>
                                <td>{gateway || 'N/A'}</td>
                                <td>
                                    <TransactionStatusBadge
                                        status={status}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            ): null}
        </>
    );
}

WalletTransactions.propTypes = {
    user: object,
};

export default WalletTransactions;